import { Info } from 'lucide-react';

const StationInfoSection = () => {
  return (
    <div className="content-card" data-testid="station-info-section">
      <div className="card-header">
        <h2>
          <Info size={20} className="inline" /> Station Information
        </h2>
      </div>
      <div className="card-content">
        <div className="station-info-container">
          <div className="info-block">
            <h3 className="info-block-title">Studio Phone</h3>
            <p className="info-block-value">01553 886999</p>
            <p className="info-block-note">For on-air calls and messages</p>
          </div>

          <div className="info-block">
            <h3 className="info-block-title">WhatsApp</h3>
            <p className="info-block-value">01553 886999</p>
            <p className="info-block-note">Message us on WhatsApp</p>
          </div>

          <div className="info-block">
            <h3 className="info-block-title">Emergency Contact</h3>
            <p className="info-block-value">Richard Dix: Station Manager</p>
            <p className="info-block-note">07786 887750</p>
          </div>

          <div className="info-block">
            <h3 className="info-block-title">Website</h3>
            <p className="info-block-value">www.kl1radio.co.uk</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StationInfoSection;